import { SelectLocationForCitation } from './SelectLocationForCitation';
import { StripeLoader } from 'src/common/StripeLoader';
import { useGetCitations } from '../hooks';
import { useClearCitationStateOnMount } from '../Providers/CitationProvider';
import { useEffect, useMemo, useState } from 'react';
import { Card, CardContent } from '@mui/material';
import { keywordOverviewCss } from 'src/content/keywordResearch/keywordOverview/keywordOverviewCSS';
import { UpgradeToAgency } from 'src/content/keywordResearch/keywordTracking/UpgradeToAgency';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/redux/store';
import { isLocalSeoUser } from 'src/common/config/FunctionHelper';
import { getCreditDetails } from 'src/common/Scraper';
import { useGoogleBusinessProfile } from 'src/components/GoogleBusinessProfileSelector/GoogleBusinessProfileProvider';
import { updateSearchesDetailsAndLimits } from 'src/common/config/FunctionHelperPartTwo';

export const CitationBuilder = () => {
  const { isFetching } = useGetCitations();
  useClearCitationStateOnMount();
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const { loading: googleBusinessProfileLoading } = useGoogleBusinessProfile();
  const {
    user,
    planDetails,
    activePlanName,
    isLocalSeoUnlockedFromState,
    searchesDetailRedux
  } = useSelector((state: RootState) => ({
    user: state.user,
    planDetails: state.user.planDetails,
    activePlanName: state.user.activePlan,
    isLocalSeoUnlockedFromState: state.localSeo.isLocalSeoUnlocked,
    searchesDetailRedux: state.keywordResearch.searchesDetails
  }));

  // Memoize computed values to avoid unnecessary recalculations
  const isLocalSeo = useMemo(() => isLocalSeoUser(), [user]);

  const isLocalSeoUnlocked = useMemo(
    () => isLocalSeoUnlockedFromState || isLocalSeo || false,
    [isLocalSeoUnlockedFromState, isLocalSeo]
  );

  const isAgency = useMemo(
    () =>
      activePlanName === planDetails?.agency ||
      activePlanName === planDetails?.expertPlus ||
      activePlanName === planDetails?.enterprise,
    [activePlanName, planDetails?.agency, planDetails?.enterprise]
  );

  const shouldShowUpgradeModal = useMemo(
    () => !isAgency && !isLocalSeoUnlocked && activePlanName,
    [isAgency, isLocalSeoUnlocked, activePlanName]
  );

  const getKeywordTrackingFunc = () => {};

  useEffect(() => {
    getCredits();
  }, []);

  const getCredits = async () => {
    setLoader(true);
    let getSearchesDetail;
    if (
      searchesDetailRedux &&
      ((Array.isArray(searchesDetailRedux) && searchesDetailRedux.length > 0) ||
        (!Array.isArray(searchesDetailRedux) &&
          Object.keys(searchesDetailRedux).length > 0))
    ) {
      getSearchesDetail = searchesDetailRedux;
    } else {
      getSearchesDetail = await getCreditDetails();
    }
    // let getSearchesDetail: any = Array.isArray(searchesDetailRedux) && searchesDetailRedux.length > 0 ? searchesDetailRedux : await getCreditDetails();
    if (getSearchesDetail) {
      updateSearchesDetailsAndLimits(getSearchesDetail);
    }
    setLoader(false);
  };

  if (isFetching || loader || googleBusinessProfileLoading) {
    return <StripeLoader />;
  }

  if (shouldShowUpgradeModal) {
    return (
      <Card sx={{ ...keywordOverviewCss?.card }}>
        <CardContent sx={keywordOverviewCss?.cardContent}>
          <UpgradeToAgency
            getKeywordTrackingFunc={getKeywordTrackingFunc}
            isLocalSeo={true}
          />
        </CardContent>
      </Card>
    );
  }

  return <SelectLocationForCitation />;
};
